import axios, {AxiosResponse} from 'axios'
import {SprintReport, SprintUser, Task} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GET_REPORTS_URL = `${API_URL}/api/relatorio`
const SPRINT_URL = `${GET_REPORTS_URL}/sprint`

export type SprintTasksExportSprint = {
  name: string
  begin_date: string
  end_date: string
}

export type SprintTasksExportTask = {
  id: number
  name: string
  project_id: number | null
  stage_name: string
  user_names: string
}

export type SprintTasksExportResponse = {
  sprint: SprintTasksExportSprint | null
  tasks: SprintTasksExportTask[]
}

export function getSprintReportById(id: string): Promise<SprintReport> {
  return axios
    .get(`${SPRINT_URL}/${id}`)
    .then((response: AxiosResponse<SprintReport>) => response.data)
}

export function getSprintUsers(id: string): Promise<SprintUser[]> {
  return axios
    .get(`${SPRINT_URL}/${id}/users`)
    .then((response: AxiosResponse<SprintUser[]>) => response.data)
}

export function getTasksByUserSprintAndStatus(sprintId: string, userId: number, status: string): Promise<Task[]> {
  return axios
    .get(`${SPRINT_URL}/${sprintId}/user/${userId}/tasks/status/${status ? status : null}`)
    .then((response: AxiosResponse<Task[]>) => response.data)
}

export function getSprintTasksExport(
  sprintId: string,
  userIds?: number[]
): Promise<SprintTasksExportResponse> {
  const params = userIds?.length ? {user_ids: userIds} : {}
  return axios
    .get(`${SPRINT_URL}/${sprintId}/export-tasks`, {params})
    .then((response: AxiosResponse<SprintTasksExportResponse>) => response.data)
}
